const translations = {
    crop: 'Crop',
    dicambaBadge: 'Dicamba',
    lastUsed: 'Last Used',
    loading: 'Loading',
    name: 'Name',
    noMixes: 'No mixes yet — tap + New Mix to create one',
    productCount_one: '{{count}} product',
    productCount_other: '{{count}} products',
    products: 'Products'
};

export default translations;
